<!--




<head>

  <meta name="viewport" content="width=device-width, initial-scale=1">

  <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css">
</head>

<div class="custom-tables" #customTable [ngClass]="{'row-layout': rowLayout, 'column-layout': !rowLayout}">
  <div class="table" [ngStyle]="{


    'border': properties?.borderStyle === '0' ? 'none' :'1px solid' + properties?.borderColor,

}">
    <div class="table-bodys2">
      <div class="header1">
        <div class="row-header header-cells" [ngStyle]="{
    'background-color': properties?.headerColor,
    'border-bottom': properties?.borderStyle === '0' || properties?.borderStyle === '1' ? 'none' : '1px solid' + properties?.borderColor,
    'border-right': properties?.borderStyle === '0' || properties?.borderStyle === '1' ? 'none' : '1px solid' + properties?.borderColor,
    'text-align': properties?.textAlign
}">
    <span [ngStyle]="{
        'color': properties?.ColumnHeaderFontColor,
        'font-size': properties?.ColumnHeaderFontSize
    }">

    </span>
</div>


      </div>

      <div class="table-rows3" *ngFor="let item of categories2;">
        <div class=" data-cells3 header-cells" [ngStyle]="{'background-color': properties?.RowHeaderCellColor,  'border-bottom': properties?.borderStyle === '0' || properties?.borderStyle === '1' ? 'none' : '1px solid' + properties?.borderColor,
  'border-right': properties?.borderStyle === '0' || properties?.borderStyle === '1' ? 'none' : '1px solid' + properties?.borderColor,'justify-content':properties?.RowHeaderAlignment}">
          <span class="data" [ngStyle]="{'color': properties?.RowHeaderFontColor,'font-size':properties?.RowHeaderFontSize}">
            {{ item.colname }}
          </span>
        </div>


      </div>

    </div>
    <div class="table-bodys">
      <div class="header columnHeader">


        <ng-container *ngFor="let header of headers2; ">
          <div class="header-cells" [ngStyle]="{'background-color': properties?.ColumnHeaderCellColor,   'border-bottom': properties?.borderStyle === '0' || properties?.borderStyle === '1' ? 'none' : '1px solid' + properties?.borderColor,
  'border-right': properties?.borderStyle === '0' || properties?.borderStyle === '1' ? 'none' : '1px solid' + properties?.borderColor,'justify-content':properties?.ColumnHeaderAlignment}">
            <span [ngStyle]="{'color': properties?.ColumnHeaderFontColor,'font-size':properties?.ColumnHeaderFontSize}">
              {{ header.colname }}
            </span>

          </div>
        </ng-container>





      </div>

      <div class="content">
        <div class="table-rows" *ngFor="let row of categories; let even = even;" [ngStyle]="{'background-color':properties?.BandedRow1?( !even ? 'rgba(' + hexToRgb(properties?.BannedRow) + ', 0.5)' :properties?.BannedRow):''}">
          <ng-container *ngIf="!shouldShowRow(row)">
            <div class="table-columns" *ngFor="let col of headers; let even1 = even;" [ngStyle]="{'background-color': properties?.BandedColumn1?( !even1 ? 'rgba(' + hexToRgb(properties?.BannedColumn) + ', 0.5)' :properties?.BannedColumn):''}">
              <ng-container *ngIf="!shouldShowCol(col)">
                <div class="data-cells"
                    [ngStyle]="{
   'border-bottom': properties?.borderStyle === '0' || properties?.borderStyle === '1' ? 'none' : '1px solid' + properties?.borderColor,
  'border-right': properties?.borderStyle === '0' || properties?.borderStyle === '1' ? 'none' : '1px solid' + properties?.borderColor,
  'justify-content': properties?.dataLabelAlignment,
  'color': properties?.dataLabelColor
}"
>
                  <span [innerHTML]="getDataCell(row, col)"
                        [ngStyle]="{
                  'color':  (properties?.dataLabelColor == 'default' && !properties?.alternateColor ? 'black' : properties?.dataLabelColor),
                  'font-size': properties?.dataLabelSize
                }">
                  </span>
                </div>
              </ng-container>
            </div>
          </ng-container>
        </div>




      </div>

    </div>


  </div>
</div>


 <pagination-controls *ngIf="!properties?.pagination" previousLabel="Prev" nextLabel="Next" (pageChange)="onTableDataChange($event)" class="pagination">
</pagination-controls> -->











<div *ngIf="!categories || categories.length === 0"
  style="display: flex; align-items: center; justify-content: center; height: calc(100% - 2rem); font-size: 0.75rem;">
  No data available for the selection.
</div>

<div class="output-common-container" [ngStyle]="{'padding':isOutput?'1%':'5%'}">
 <div *ngIf="categories && categories.length > 0"
  id="table-scroll"
  class="table-scroll"
  [ngStyle]="{
    '--custom-margin': getMarginForScroll(),
    'border': properties?.borderStyle === '0'
      ? 'none'
      : '1px solid ' + properties?.borderColor,
    'justify-content': properties?.ColumnHeaderAlignment,
    
    'max-height': isOutput
      ? (
          height == '1rem'
            ? (properties?.CalculationLogic != 'BIPS' ? '14rem' : '13rem') 
            : height == '0.5rem'
              ? (properties?.CalculationLogic != 'BIPS' ? '10rem' : '9rem')
              : height == '9rem'
                ? (properties?.CalculationLogic == 'BIPS'
                ? 'calc(100% - 4rem)'
                : 'calc(100% - 2rem)')
                : '27rem'
        )
      : '50vh',

    'width': 'auto'
  }">





    <table id="main-table" class="main-table">
      <thead>
        <tr>
          <th class="FreezedColumn"
            [ngStyle]="{'border-bottom': properties?.borderStyle === '0' || properties?.borderStyle === '1' ? 'none' : '1px solid' + properties?.borderColor,
          'border-right': properties?.borderStyle === '0' || properties?.borderStyle === '1' ? 'none' : '1px solid' + properties?.borderColor,'justify-content':properties?.ColumnHeaderAlignment,
          'position':properties?.FreezeFirstRow!=undefined?(properties?.FreezeFirstRow==true?'sticky':'relative'):'sticky','z-index': 3}"></th>
          <th *ngFor="let header of headers"
            [ngStyle]="{'border-bottom': properties?.borderStyle === '0' || properties?.borderStyle === '1' ? 'none' : '1px solid' + properties?.borderColor,
          'border-right': properties?.borderStyle === '0' || properties?.borderStyle === '1' ? 'none' : '1px solid' + properties?.borderColor,
          'background-color': 'var(--BHP-Primary-LightGreen2, #f7f7f7)',
          'position': properties?.FreezeFirstRow != undefined ? (properties?.FreezeFirstRow == true ? 'sticky' : 'relative') : 'sticky',
          'z-index': 2}">
            <div class="Headers">
              <div class="col-header-block"
                [ngStyle]="{'justify-content':properties?.ColumnHeaderAlignment,'width':properties?.ColumnHeaderSorting && isOutput?'80%':'100%'}">
                <span class="header-col-text" title="{{ header }}"
                  [ngStyle]="{'color': properties?.ColumnHeaderFontColor,'font-size':properties?.ColumnHeaderFontSize,'text-align':properties?.ColumnHeaderAlignment}">
                  {{ header }}
                </span>
                <!-- <div class="ascendingsort" (click)="sortTableDataAscending(header)" [ngClass]="{'ascendingselected':selectedColumn==header && selectedascending=='asc'}"></div>
              <div class="descendingsort" (click)="sortTableDataDescending(header)" [ngClass]="{'descendingselected':selectedColumn==header && selectedascending=='desc'}"></div> -->
              </div>
              <div class="Sorting"
                [ngStyle]="{'display': properties?.ColumnHeaderSorting && isOutput?'flex':'none','width':properties?.ColumnHeaderSorting && isOutput?'20%':'0%'}">
                <div class="ascendingsort" (click)="sortTableDataAscending(header)"
                  [ngClass]="{'ascendingselected':properties?.selectedColumn==header && properties?.selectedsorting=='asc'}">
                </div>
                <div class="descendingsort" (click)="sortTableDataDescending(header)"
                  [ngClass]="{'descendingselected':properties?.selectedColumn==header && properties?.selectedsorting=='desc'}">
                </div>
              </div>
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of categories; let i = index">
          <td
            [ngStyle]="{'border-bottom': properties?.borderStyle === '0' || properties?.borderStyle === '1' ? 'none' : '1px solid' + properties?.borderColor,
          'border-right': properties?.borderStyle === '0' || properties?.borderStyle === '1' ? 'none' : '1px solid' + properties?.borderColor,'justify-content':properties?.ColumnHeaderAlignment,
          'background-color': 'white','position':properties?.FreezeFirstColumn!=undefined?(properties?.FreezeFirstColumn==true?'sticky':'relative'):'sticky','z-index':2}">
            <div class="first-col-block" [ngStyle]="{'justify-content':'right'}">
              <div class="first-col-row-name" title="{{ row}}"
                [ngStyle]="{'color': properties?.RowHeaderFontColor, 'font-size': '0.685rem', 'text-align': 'right'}"
                [innerHTML]="GetRowName(row)">
              </div>
            </div>
          </td>
          <td *ngFor="let col of headers; let j = index"
            [ngStyle]="{'border-bottom': properties?.borderStyle === '0' || properties?.borderStyle === '1' ? 'none' : '1px solid' + properties?.borderColor,
          'border-right': properties?.borderStyle === '0' || properties?.borderStyle === '1' ? 'none' : '1px solid' + properties?.borderColor,
          'background-color': properties?.BandedRow1 ? (i % 2 === 1 ? 'rgba(' + hexToRgb(properties?.BannedRow) + ', 0.5)' : properties?.BannedRow) :
          (properties?.BandedColumn1 ? (j % 2 === 1 ? 'rgba(' + hexToRgb(properties?.BannedColumn) + ', 0.5)' : properties?.BannedColumn) : '') ,'z-index':1}">
            <div class="output-cell-text" *ngIf="!properties.enableDataBars"
              [ngStyle]="{'justify-content':properties?.dataLabelAlignment}">
              <div [ngStyle]="{'color': properties?.dataLabelColor}" [innerHTML]="getDataCell(row, col)"></div>
              <span style="font-size: 80%;" [ngStyle]="{'display':isOutput && !shouldHideSignificance(getDataCell(row, col)) ?'block':'none'}"
                [style.color]="getSigCell(row, col)" [innerHTML]="getChangeVsCell(row, col)"></span>
            </div>
            <div class="output-cell-text bar-container"
              *ngIf="properties.CalculationLogic=='None' && properties.enableDataBars">
              <div *ngIf="isValueLessThanZero(getDataCell(row, col))" class="negative-container">
                <div class="negative-value" [innerHTML]="getDataCell(row, col)"></div>
                <span class="negative-sig-value" style="font-size: 80%;" [ngStyle]="{'display':isOutput && !shouldHideSignificance(getDataCell(row, col)) ?'block':'none'}"
                [style.color]="getSigCell(row, col)" [innerHTML]="getChangeVsCell(row, col)"></span>
              </div>
              <div class="bar" [ngClass]="getBarClass(getDataCell(row, col))"
                [ngStyle]="{'width': getBarWidth(getDataCell(row, col)),'background-color': getBarColor(row, col)}">
              </div>
              <div *ngIf="isValueGreaterThanZero(getDataCell(row, col))" class="positive-container">
                <div class="positive-value" [innerHTML]="getDataCell(row, col)" [style]="'font-size: 0.685rem;left : 2px ;margin-left: calc(' + getBarWidth(getDataCell(row, col)) + ' + 3px) !important'"></div>
               <span class="positive-sig-value" style="font-size: 80%; top:0.7rem;"
              [ngStyle]="{'display': isOutput && !shouldHideSignificance(getDataCell(row, col)) ? 'block' : 'none'}"
              [style.margin-left]="(height === '9rem' || height === '0.5rem')  ?  'calc(' + getBarWidth(getDataCell(row, col)) + ' + -6.4rem)' : 'calc(' + getBarWidth(getDataCell(row, col)) + ' + -3rem)'"
              [style.color]="getSigCell(row, col)"
              [innerHTML]="getChangeVsCell(row, col)">
              </span>
              </div>
              <div *ngIf="isValueEqualToZero(getDataCell(row, col))" class="zero-container">
                <div class="zero-value" [innerHTML]="getDataCell(row, col)"></div>
                <span style="font-size: 80%;" [ngStyle]="{'display':isOutput && !shouldHideSignificance(getDataCell(row, col)) ?'block':'none'}"
                [style.color]="getSigCell(row, col)"  [style]="'font-size:0.685rem'"[innerHTML]="getChangeVsCell(row, col)"></span>
              </div>
            </div>
            <div class="output-cell-text bar-container bips-calculation"
              *ngIf="properties.CalculationLogic=='BIPS' && properties.enableDataBars">
              <div *ngIf="isValueLessThanZero(getDataCell(row, col))" class="negative-container">
                <div class="negative-value" [innerHTML]="getDataCell(row, col)" [style]="'font-size:0.685rem;margin-left: calc(-10% - '+getBarWidth(getDataCell(row, col))+') !important'"></div>
              </div>
              <div class="bar" [ngClass]="getBarClass(getDataCell(row, col))"
                [ngStyle]="{'width': getBarWidth(getDataCell(row, col)),
                'background-color':getBarClass(getDataCell(row, col))=='positive'?(properties.bipsPositiveRange!=null?(getActualNumber(getDataCell(row, col))>=properties.bipsPositiveRange?properties.bipsPositiveRangeColor:bipsDefaultColor):bipsDefaultColor):(properties.bipsNegativeRange!=null?(getActualNumber(getDataCell(row, col))<=properties.bipsNegativeRange?properties.bipsNegativeRangeColor:bipsDefaultColor):bipsDefaultColor)}">
              </div>
              <div *ngIf="isValueGreaterThanZero(getDataCell(row, col))" class="positive-container">
                <div class="positive-value" [innerHTML]="getDataCell(row, col)" [style]="'font-size:0.685rem;margin-left: calc(' + getBarWidth(getDataCell(row, col)) + ' + 6px) !important'"></div>
              </div>
              <div *ngIf="isValueEqualToZero(getDataCell(row, col))" class="zero-container">
                <div class="zero-value" [style]="'font-size:0.685rem'"[innerHTML]="getDataCell(row, col)"></div>
              </div>

            </div>

          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="bipsFooterNote" *ngIf="properties.CalculationLogic=='BIPS'">
     <div class="positiveBipsNote">
      <div class="square" [style]="'background-color:'+properties.bipsPositiveRangeColor"></div>
    <span>
      Defines Brand ({{(properties.bipsPositiveRange>=0?"+":"")+properties.bipsPositiveRange}} or more)
    </span>
     </div>
     <div class="negativeBipsNote">
      <div class="square" [style]="'background-color:'+properties.bipsNegativeRangeColor"></div>
      <span>
      Defines Brand ({{(properties.bipsNegativeRange>=0?"+":"")+properties.bipsNegativeRange}} or less)
    </span>
     </div>
  </div>
</div>
